module.exports = __webpack_public_path__ + "img/pin_take_away_blue.2296ee4f.svg";